// src/features/clipboard/copiedClipboardSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { EncounterWIthItemInvoiceSerializer } from "@/types/encounterItem"

export type ClipboardType = "encounterDx" | "encounterUuid" | "all" | "plainNote"
export type ClipboardSourceType = "history" | "set" | "manual" | null

export interface ClipboardCopyNotice {
  title?: string
  message: string
}

interface CopiedClipboardState {
  copied: EncounterWIthItemInvoiceSerializer
  lastCopiedType: ClipboardType | null
  copiedAt: number // 타임스탬프 추가
  sourceType: ClipboardSourceType
  copyNotice: ClipboardCopyNotice | null
  loading: boolean
  error: string | null
}

const initialState: CopiedClipboardState = {
  copied: {},
  lastCopiedType: null,
  copiedAt: Date.now(), // 타임스탬프 추가
  sourceType: null,
  copyNotice: null,
  loading: false,
  error: null,
}

const copiedClipboardSlice = createSlice({
  name: "copiedClipboard",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    setCopiedContent(
      state,
      action: PayloadAction<{
        type: ClipboardType
        content: EncounterWIthItemInvoiceSerializer
        sourceType?: ClipboardSourceType
        copyNotice?: ClipboardCopyNotice | null
      }>
    ) {
      state.copied = action.payload.content
      state.lastCopiedType = action.payload.type
      state.copiedAt = Date.now() // 타임스탬프 업데이트
      state.sourceType = action.payload.sourceType ?? null
      state.copyNotice = action.payload.copyNotice ?? null
    },
    clearCopiedContent(state, action: PayloadAction<ClipboardType>) {
      state.copied = { [action.payload]: null } as EncounterWIthItemInvoiceSerializer
      state.lastCopiedType = null
      state.copiedAt = 0
      state.sourceType = null
      state.copyNotice = null
    },
    clearAllCopied(state) {
      state.copied = {}
      state.lastCopiedType = null
      state.copiedAt = 0
      state.sourceType = null
      state.copyNotice = null
    },
  },
})

export const { setLoading, setError, setCopiedContent, clearCopiedContent, clearAllCopied } = copiedClipboardSlice.actions

export default copiedClipboardSlice.reducer
